// 플러그인 내부 상태 — 관찰 훅이 쓰고 위젯이 읽는다. 다른 플러그인과 공유하지 않는다
import { useSyncExternalStore } from 'react';

import { tally, total, type ActionTally } from '../domain/action-tally';

let state: ActionTally = {};
const listeners = new Set<() => void>();

export function recordAction(action: string): void {
  state = tally(state, action);
  listeners.forEach(notify => notify());
}

/** 플러그인 dispose·테스트 사이에 상태를 비운다 */
export function resetActionCount(): void {
  state = {};
  listeners.forEach(notify => notify());
}

export function useCompletedActionCount(): number {
  return useSyncExternalStore(
    notify => {
      listeners.add(notify);
      return () => listeners.delete(notify);
    },
    () => total(state),
  );
}
